export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-400 bg-accent-100/15 px-3 py-1 rounded-full mb-4 whitespace-nowrap">
            <i className="ri-mail-send-line"></i>
            Get In Touch
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            联系我们
          </h2>
          <p className="text-sm text-foreground-500">有猛料？有线索？欢迎随时联系我们</p>
        </div>

        <div className="bg-background-100 border border-background-200/60 rounded-xl p-8 md:p-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center p-4">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-500/10 flex items-center justify-center">
                <i className="ri-mail-line text-xl text-primary-400"></i>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-200 mb-1">爆料投稿</h3>
              <p className="text-xs text-foreground-500">tips@51heiliaowang.com</p>
            </div>
            <div className="text-center p-4">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-500/10 flex items-center justify-center">
                <i className="ri-chat-smile-2-line text-xl text-accent-400"></i>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-200 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-500">biz@51heiliaowang.com</p>
            </div>
            <div className="text-center p-4">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-500/10 flex items-center justify-center">
                <i className="ri-shield-user-line text-xl text-secondary-400"></i>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-200 mb-1">侵权投诉</h3>
              <p className="text-xs text-foreground-500">legal@51heiliaowang.com</p>
            </div>
          </div>
          <p className="text-center text-xs text-foreground-600 mt-6">
            51黑料网承诺对所有爆料人信息严格保密 · 工作日24小时内回复
          </p>
        </div>
      </div>
    </section>
  );
}